<template>
  <div>
    <div class="side-frame-success d-flex">
      <span style="font-size: 14px; color:#6C6C6C;line-height: 28px;">
        {{ $l('table_label_sku_product_list') || 'SKU产品列表' }}
      </span>
      <SearchTabs
        class="ml-2"
        v-model="tab"
        :options="searchTabOpts"
        @change="changeTab"
      ></SearchTabs>
    </div>
    <b-row align-h="start">
      <b-col cols="4" style="padding-right: 7px;">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                  'SPU中英文名称/品牌/系列/品类/SPU编号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
      <b-button
        v-if="allow('A') && addSku && tab == 'ALL'"
        size="sm"
        variant="outline-primary"
        @click="$emit('handleCommand')"
        style="width:91px;"
      >
        {{ $l('btn_new_sku') || '新增SKU' }}
      </b-button>
      <el-badge
        v-if="allow('B') && addSku && (tab == 'ALL' || tab == 'Y')"
        :value="checkedCount"
        class="item"
        style="margin-bottom: 1px;"
      >
        <b-button
          class="ml-2"
          size="sm"
          variant="outline-primary"
          @click="$emit('updateDesignVisible')"
          v-if="allow('B') && addSku && (tab == 'ALL' || tab == 'Y')"
          :disabled="!checkedCount"
          style="width:108px;"
        >
          {{ $l('INDEX.btn_change_design_name') || '企划人员调整' }}
        </b-button>
      </el-badge>
      <el-badge
        v-if="allow('SS') && addSku && tab == 'Q'"
        :value="checkedCount"
        class="item"
        style="margin-bottom: 1px;"
      >
        <b-button
          class="ml-2"
          size="sm"
          variant="outline-primary"
          v-if="allow('SS') && addSku && tab == 'Q'"
          :disabled="!checkedCount"
          style="width:135px;"
          @click="$emit('informationReview')"
        >
          {{
            $l('btn_batch_submission_information_review') || '批量提交信息审核'
          }}
        </b-button>
      </el-badge>
      <el-badge
        v-if="allow('SG') && addSku && tab == 'C'"
        :value="checkedCount"
        class="item"
        style="margin-bottom: 1px;"
      >
        <b-button
          class="ml-2"
          size="sm"
          variant="outline-primary"
          v-if="allow('SG') && addSku && tab == 'C'"
          :disabled="!checkedCount"
          style="width:135px;"
          @click="$emit('purchasableApply')"
        >
          {{
            $l('btn_batch_submission_for_order_placement') || '批量提交转可下单'
          }}
        </b-button>
      </el-badge>

      <b-button
        class="ml-3"
        size="sm"
        variant="outline-success"
        @click="$emit('chooseAmzSkuVisible')"
        v-if="allow('SC') && addSku && tab == 'ALL'"
        style="width:109px;"
      >
        {{ $l('INDEX.table_label_Selectexistingsku') || '选择已有Sku' }}
      </b-button>

      <el-badge
        v-if="allow('SR') && addSku && tab == 'ALL'"
        :value="checkedCount"
        style="margin-bottom: 1px;"
        class="item"
      >
        <b-button
          class="ml-2"
          size="sm"
          variant="outline-danger"
          v-if="allow('SR') && addSku && tab == 'ALL'"
          :disabled="!checkedCount"
          @click="$emit('remove')"
          style="width:109px;"
        >
          {{ $l('btn_remove_sku') || '移除SKU' }}
        </b-button>
      </el-badge>

      <el-badge
        v-if="allow('ST') && addSku && tab == 'ALL'"
        :value="checkedCount"
        style="margin-bottom: 1px;"
        class="item"
      >
        <b-button
          class="ml-3"
          size="sm"
          variant="outline-dark"
          :disabled="!checkedCount"
          @click="$emit('uploadTech')"
        >
          {{ $l('btn_update_doc') || '分配工艺说明' }}
        </b-button>
      </el-badge>
    </b-row>
  </div>
</template>

<script>
import SearchTabs from './tabs'

// 初始表单
const initForm = {
  keyword: '',
  amzSpuStatusList: ['Q', 'Y'],
  listApplicationStatus: [],
  isVcList: [],
}
export default {
  components: { SearchTabs },

  props: {
    checkedCount: { type: Number, default: 0 },
    addSku: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { ...initForm },
      tab: 'ALL',
    }
  },
  computed: {
    searchTabOpts() {
      return [
        {
          label: '全部',
          value: 'ALL',
        },
        {
          label: '企划',
          value: 'Q',
        },
        {
          label: '已确认',
          value: 'C',
        },
        {
          label: '可下单',
          value: 'P',
        },
        {
          label: '正式',
          value: 'Y',
        },
      ]
    },
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', {
        ...this.form,
        amzSkuStatus: this.tab == 'ALL' ? ['Q', 'C', 'P', 'Y'] : [this.tab],
      })
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    changeTab(value) {
      this.tab = value
      this.query()
      this.$emit('resetChecked')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}

.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid #67c23a;
  margin: 6px 0;
}
</style>
